var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9C12.75 8.30964 13.3096 7.75 14 7.75C14.6904 7.75 15.25 8.30964 15.25 9V12.75H19C19.6904 12.75 20.25 13.3096 20.25 14C20.25 14.6904 19.6904 15.25 19 15.25H15.25V19C15.25 19.6904 14.6904 20.25 14 20.25C13.3096 20.25 12.75 19.6904 12.75 19V15.25H9C8.30964 15.25 7.75 14.6904 7.75 14C7.75 13.3096 8.30964 12.75 9 12.75H12.75V9Z",
    fill: "#4B4B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.75 14C27.75 21.5939 21.5939 27.75 14 27.75C6.40608 27.75 0.25 21.5939 0.25 14C0.25 6.40608 6.40608 0.25 14 0.25C21.5939 0.25 27.75 6.40608 27.75 14ZM2.75854 14C2.75854 20.2085 7.79151 25.2415 14 25.2415C20.2085 25.2415 25.2415 20.2085 25.2415 14C25.2415 7.79151 20.2085 2.75854 14 2.75854C7.79151 2.75854 2.75854 7.79151 2.75854 14Z",
    fill: "#4B4B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.16824ad1e72831a5239bfaadbc278524.svg";
export { ForwardRef as ReactComponent };